import { render, staticRenderFns } from "./Page034.vue?vue&type=template&id=2670b6fb&scoped=true&"
import script from "./Page034.vue?vue&type=script&lang=js&"
export * from "./Page034.vue?vue&type=script&lang=js&"
import style0 from "./Page034.vue?vue&type=style&index=0&id=2670b6fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670b6fb",
  null
  
)

export default component.exports